// Mobile-first app shell layout

import { ReactNode } from 'react'
import Header from './Header'

interface LayoutProps {
  children: ReactNode
  showHeader?: boolean
}

export default function Layout({ children, showHeader = true }: LayoutProps) {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      {showHeader && <Header />}
      <main className="flex-1 flex flex-col">
        {children}
      </main>
    </div>
  )
}
